import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { Typeahead } from "../../Typeahead";
import { useFormContext } from "../../Form";
export const FutureAsyncFilter = ({ onChange, loadOptions, label, formatter, extraClass, direction = "right", name, id, }) => {
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const { values } = useFormContext();
    const existingFormValue = values.get(name) ?? null;
    const elementRef = useRef(null);
    const mouseDownHandler = useCallback((ev) => {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    const onTypeaheadChange = useCallback((selected) => {
        /** TODO useReducer to handle states */
        if (selected) {
            if (onChange) {
                onChange(selected);
            }
            if (isMenuVisible)
                setIsMenuVisible(false);
        }
        else {
            if (onChange) {
                onChange(selected);
            }
            if (isMenuVisible)
                setTimeout(() => {
                    setIsMenuVisible(false);
                });
        }
    }, [onChange, isMenuVisible]);
    const keyFunctions = useCallback((event) => {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, [setIsMenuVisible]);
    useEffect(() => {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return () => {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [keyFunctions, mouseDownHandler, isMenuVisible]);
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: () => setIsMenuVisible(!isMenuVisible), label: label, value: existingFormValue &&
                (formatter ? formatter(existingFormValue) : existingFormValue.name) },
            React.createElement("div", { className: `affectBar--filter-box affectBar--filter-box--${direction} ${extraClass ? extraClass : ""}` },
                React.createElement(Typeahead, { name: name, loadOptions: loadOptions, onChange: onTypeaheadChange, label: label, formatter: formatter, autoFocus: true, uniqueId: id })))));
};
